import { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/user";
import { GroupContext } from "../contexts/group";
import { Grid } from "@mui/material";
import { getGroupsByUserId, getUserTIMRol, getisCompletedAssessmentTIM } from "../axios/axiosFunctions";
import WelcomeIntro from "./WelcomeIntro";
import BlockSection from "./BlockSection";
import GroupCard from "./GroupCard";

const TIMTeams = ({currentAssessment,blockLength}) => {
        
    const {currentUser} = useContext(UserContext);
    const {currentGroup, setCurrentGroup,level,setLevel} = useContext(GroupContext);
    const [blocks, setBlocks] = useState(currentAssessment?.blocks);
    const [allGroups, setAllGroups] = useState([]);
    const [lastCompleted, setLastCompleted] = useState({last:"",pos:0});

    useEffect(() => {
      callGroups();
      localStorage.setItem("groupLL",JSON.stringify({group:currentGroup,level}));
    }, [])

    useEffect(() => {
        if(currentAssessment && currentGroup){
            checkIfComplete();
            callUserType();
        }
    }, [currentAssessment,currentUser,currentGroup]);

    const callUserType = async()=>{
        const res = await getUserTIMRol(currentGroup?._id,currentUser._id);
        if(res){ 
            calculateBlock(res.timRol[0]?.rol || "member");
        }
    }

    const calculateBlock = (rol)=>{
        if(rol === "member" && blocks.length === blockLength){
            const newBloks = [...currentAssessment?.blocks];
            newBloks.pop();
            setBlocks(newBloks);
        }
        if(rol === "senior"){
            const newBloks = [...currentAssessment?.blocks];
            setBlocks([newBloks[newBloks.length - 1]]);
        }
    }
    const checkIfComplete = async(groupId = currentGroup._id)=>{    
        const isComplete = await getisCompletedAssessmentTIM(currentAssessment._id,currentUser._id,groupId);
        setLastCompleted(isComplete.slug);
        return isComplete;
    }
    
    const callGroups = async()=>{
        const res = await getGroupsByUserId(currentUser._id);
        setAllGroups(res.groups);
    }

    const changeLevel = (newLevel,group)=>{
        setLevel(newLevel);
        setCurrentGroup(group);
        const storagedInfo = {
            group,
            level:newLevel
        };
        localStorage.setItem("groupLL",JSON.stringify(storagedInfo));
    }
    
    console.log(lastCompleted);

    return (
    <>
    {
        level === 0 && 
        <Grid container spacing={5} sx={{marginTop:"50px"}}>
            {
                allGroups.map((g,i)=>(
                    <GroupCard key={i} group={g} changeLevel={changeLevel} checkIfComplete={checkIfComplete}/>
                ))
            }
        </Grid>
    }
    {
        level === 1 && 
        <>
            <WelcomeIntro introText={currentAssessment?.introText} mainImage={currentAssessment?.mainImage} slug={lastCompleted}/>
            <BlockSection name={currentAssessment?.name} blocks={blocks} assessmentId={currentAssessment?._id}/>
        </>
    }
    </>
    )
}

export default TIMTeams